import React, { useMemo } from 'react';
import ChannelContext from './ChannelContext';
import { useCookies } from 'react-cookie';
const ChannelProvider = ({ channelHandler, children, config }) => {
    const [cookies] = useCookies(['culture']);
    const { channels, selectedChannel, recommendedChannel, selectedChannelGroup } = channelHandler;
    const value = useMemo(() => {
        const updateChannelSingleDomain = (newChannel) => {
            channelHandler.updateChannel({ config, newChannel });
        };
        function setCultureForPreview(culture) {
            channelHandler.setSelectedChannel(Object.assign(Object.assign({}, selectedChannel), { language: Object.assign(Object.assign({}, selectedChannel.language), { culture }) }));
        }
        function restoreCultureForPreview() {
            channelHandler.setSelectedChannel(Object.assign(Object.assign({}, selectedChannel), { language: Object.assign(Object.assign({}, selectedChannel.language), { culture: cookies.culture }) }));
        }
        const channelsById = {};
        channels &&
            channels.forEach((channel) => {
                channelsById[channel.id] = channel;
            });
        return {
            recommendedChannel,
            updateChannel: updateChannelSingleDomain,
            channels,
            selectedChannel,
            channelsById,
            setCultureForPreview,
            restoreCultureForPreview,
            selectedChannelGroup,
            basename: channelHandler.getChannelBasename() // TODO This isn't used anywhere?
        };
    }, [
        channelHandler,
        channels,
        config,
        cookies.culture,
        recommendedChannel,
        selectedChannel,
        selectedChannelGroup
    ]);
    return (React.createElement(ChannelContext.Provider, { value: value }, children));
};
export default ChannelProvider;
//# sourceMappingURL=ChannelProvider.js.map